import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import PublicFooterXL from './PublicFooterXL'
import PublicFooterXS from './PublicFooterXS'

export default function PublicFooter () {
  const screens = useBreakpoint()

  return (
    <>
      {screens.xs && <PublicFooterXS />}
      {!screens.xs && <PublicFooterXL />}
    </>
  )
}
